<!--
 * @Descripttion: 
 * @version: 
 * @Author: youquan.yu
 * @Date: 2020-08-11 09:52:56
 * @LastEditors: youquan.yu
 * @LastEditTime: 2020-09-28 10:05:37
-->
<template>
    <div class="MainDiv">
        <div class="LeftDiv">
            <div class="QASearchDiv">
                <vQASearch></vQASearch>
            </div>
        </div>
        <div class="RightDiv">           
            <div class="UserInfoDiv" v-if="username">
                <vUserInfo></vUserInfo>
            </div>
            <!-- <div class="RightLineDiv" v-if="username">
                <hr style="height:1px;border: none;border-top:1px solid #D8D8D8;"/>
            </div> -->
        </div>
    </div>
</template>
<script>
    import vQASearch from '../components/AnswerAndQuestion/QASearch'
    import vUserInfo from '../components/Home/UserInfo'
    export default {
        name: 'dashboard',
        data() {
            return {
                username: localStorage.getItem("userName_ats"),
            }
        },
        components: {
            vQASearch,
            vUserInfo,
        },
    }

</script>
<style scoped>
    .LeftDiv {
        border-radius: 2px;
        border-radius: 2px;
        width: 744px;
        height: auto;
        background: #FFFFFF;
        margin-top: 15px;
        display: inline-block;
    }
    .QASearchDiv {
        width: 744px ;
    }
    .RightDiv {
        border-radius: 2px;
        border-radius: 2px;
        padding-bottom: 30px;
        width: 366px;
        height: auto;
        float: right;
        background: #FFFFFF;
        margin-top: 15px;
        margin-left: 10px;
    }
    .RightLineDiv {
        width: 342px;
        padding: 12px 40px 16px 12px;
    }
</style>